import { render, staticRenderFns } from "./cartas.vue?vue&type=template&id=f5049110&scoped=true"
import script from "./cartas.vue?vue&type=script&lang=js"
export * from "./cartas.vue?vue&type=script&lang=js"
import style0 from "./cartas.vue?vue&type=style&index=0&id=f5049110&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5049110",
  null
  
)

export default component.exports